export const ANALYTICS_ACTION_TYPE = {
  COPY_LINK: 'copy_link',
  SHARE: 'send_from_calendly'
}

export const SUL_ANALYTICS_TYPES = {
  SFC_CUSTOMIZED_DETAILS: 'sfcCustomizedDetails',
}
